import React from "react";
import {
  Table, Input, Row, Col, Pagination, Button, Spin, notification, Popconfirm, 
  Form, FormInstance, Modal, Select, Badge, Breadcrumb, Space, Checkbox, Upload,
  Empty,
  Radio,
} from "antd";
import { RootStoreModel } from "../../redux/reducers";
import { Link, NavLink, RouteComponentProps } from "react-router-dom";
import { connect } from "react-redux";
import { BasicStateForListModel } from "../models";
import dayjs from 'dayjs';
import { CancelTokenSource, IsCancel } from "../../axios/axios.core";
import { 
  getCertificates, deleteCertificate, 
  downloadCertificate, uploadCertificate 
} from "../../axios/api.certificate";
import { gaEvent } from "../../withTracker"
import { getOrgsOptionsSelector, treeNode } from "@redux/selector";
import { UploadOutlined, PlusOutlined, InfoCircleOutlined } from "@ant-design/icons";

import { Translation } from "react-i18next";

interface stateModel extends BasicStateForListModel {
  isModalVisible: boolean;
  orgOptions: any[];
  tagList: any[],
  tableDropdownVisible:boolean,
  tableColumns:any[],
  file: any,
  password: any,
  fileType: string,
  fileUrl: string
}

interface propsModel extends RouteComponentProps<any, any, any> {
  orgOptions: treeNode[],
  tokenSuccess: boolean
}

const mapStatetoProps = (state: RootStoreModel) => ({
  orgOptions: getOrgsOptionsSelector(state),
  tokenSuccess: state.userState.tokenSuccess
});

const downloadCertificateFile = (id: string, item: any) => {
  downloadCertificate(id).then(
    (res) => {      
      let downloadElement = document.createElement('a');
      let href = window.URL.createObjectURL(new Blob([res]));  // 创建下载的链接
      downloadElement.href = href;
      downloadElement.download = item.name || "temp.txt";      // 下载后文件名
      document.body.appendChild(downloadElement);    
      downloadElement.click();                                 // 点击下载
      document.body.removeChild(downloadElement);              // 下载完成移除元素
      window.URL.revokeObjectURL(href);                        // 释放掉blob对象   
    },
    () => {
      notification.error({ message: <Translation>{t => {return t("下载失败")}}</Translation> });
    },
  );
}

const defaultTableColumnTem = (that: any) => {  
  return [
    {
      title: '证书状态',
      dataIndex: 'certificateStatus',
      key: 'certificateStatus',
      render:(v:any) => (
        <Badge 
          color={v === 1 ? "green" : v === 2 ? "yellow" : v === 3 ? "red" : "gray"} 
          text={v === 1 ? "正常" : v === 2 ? "即将过期" : v === 3 ? "已过期" : "未知"} 
        />
      )
    },
    {
      title: '证书名称',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: '有无密码',
      dataIndex: 'hasPassword',
      key: 'hasPassword',
      render: (v: any) => <Badge>{v ? "有" : "无"}</Badge>
    },
    {
      title: '到期日',
      dataIndex: 'expireDate',
      key: 'expireDate',
      render: (v: any) => {
        const date = dayjs(new Date(v))
        return date.format("YYYY/MM/DD")
      }
    },
    {
      title: '剩余有效期',
      dataIndex: 'remainingDays',
      key: 'remainingDays',
      render: (v: any) => <Badge>{v + "天"}</Badge>
    },
    {
      title: '操作',
      dataIndex: 'id',
      key: 'id',
      render: (id: string, item: any) => {      
        return (
          <Translation>{t => {
            return (
              <Space size={8}>
                  {item.fileType == 'Upload' && <Button 
                      onClick={() => {               
                          downloadCertificateFile(id, item)
                      }} 
                      type="link" block>{t("下载")}
                  </Button>
                  }
                  {item.fileType == 'Url' && <Button
                    onClick={() => window.open(item.fileUrl, '_blank')}
                    type="link" 
                    block>{t("下载")}</Button>
                  }
                  <Popconfirm
                      title={`${t("确认删除")}？`}
                      onConfirm={() => {
                        that.onDelete(id)
                        gaEvent("certificate", "onClick", "deleteCertificate") 
                      }}
                      okText={t("确认")}
                      cancelText={t("取消")}
                  >
                      <Button type="link" block>{t("删除")}</Button>
                  </Popconfirm>
              </Space>
            )
          }}</Translation>
        );
      }
    },
  ]
}

class CertificateListPage extends React.Component<propsModel, stateModel> {
  formRef = React.createRef<FormInstance>();
  constructor(props: propsModel) {
    super(props);
    this.state = {
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      columns: [],
      data: [],
      isModalVisible: false,
      orgOptions: [],
      tagList: [],
      tableDropdownVisible:false,
      tableColumns:defaultTableColumnTem(this),
      file: "",
      password: "",
      fileType: 'Upload',
      fileUrl: ''
    };
  }
  cancelToken = CancelTokenSource();

  componentDidMount() {
    if (this.props.tokenSuccess) {
      this.getList();
    }

  }

  componentDidUpdate(prevProps: propsModel) {
    if (this.props.tokenSuccess != prevProps.tokenSuccess) {
      this.getList();
    }
  }

  componentWillUnmount() {
    this.setState = () => { }
    this.cancelToken.cancel("cancel axios http request");
  }

  onSearch = () => {
    this.getList(1);
  };

  getList = (
    pageIndex = this.state.pageIndex,
    pageSize = this.state.pageSize
  ) => {
    this.formRef?.current?.validateFields().then((res:any)=>{
      const {
        certificateStatus,
        remainingDay,
      } = res;      
      this.setState({ loading: true });
      getCertificates({
        pageIndex,
        pageSize,
        status: certificateStatus,
        remainingDay
      }).then((res) => {
        const { dataList } = res;
        this.setState({
          data: dataList.map((item, i) => ({ ...item, key: i })),
          pageSize: res.pageSize,
          pageIndex: res.pageIndex,
          loading: false,
          totalCount: res.totalCount,
        });
      });
    })
    
  };

  onOk = () => {  
    const { file, password,fileType,fileUrl } = this.state;
    if(fileType == 'Upload')
    {
      if (!file) return notification.warning({ message: <Translation>{t => {return t("证书文件不能为空")}}</Translation> });
    }
    else
    {
      if (fileUrl == '') return notification.warning({ message: <Translation>{t => {return t("文件链接不能为空")}}</Translation> });
    }
    this.setState({ loading: true });
    uploadCertificate({
      certificate: file,
      Password: password,
      fileType: fileType,
      fileUrl: fileUrl
    }).then(
      () => {
        notification.success({ message: <Translation>{t => {return t("添加证书成功")}}</Translation> });
        this.setState({ loading: false, file: "", password: "", isModalVisible: false,fileUrl:"" });
        this.getList(1);
      },
      () => {
        notification.error({ message: <Translation>{t => {return t("添加证书失败")}}</Translation> });
        this.setState({ loading: false, file: "", password: "",fileUrl:"" });
      }
    );
  };
  
  onDelete = (id: string) => {
    this.setState({ loading: true });
    deleteCertificate(id).then(
      () => {
        notification.success({ message: <Translation>{t => {return t("已删除")}}</Translation> });
        this.setState({ loading: false });
        this.getList(1);
      },
      () => {
        notification.error({ message: <Translation>{t => {return t("删除失败")}}</Translation> });
        this.setState({ loading: false })
      }
    );
  };

  onSearchReset=()=>{
    this.formRef?.current?.resetFields();
    this.getList(1)
  }

  uploadFile = (res: any) => {    
    const { file } = res;
    this.setState({ file: file });
  };

  render() {
    const {
      loading,
      data,
      pageSize,
      pageIndex,
      totalCount,
      isModalVisible,
      tableColumns,
      fileType,
      fileUrl
    } = this.state;
    
    return (
      (<Translation>{t => {
          return (
            (<div>
              <div className="breadcrumbTop py-2">
                <Breadcrumb>
                  <Breadcrumb.Item>{t("内容")}</Breadcrumb.Item>
                  <Breadcrumb.Item>{t("证书")}</Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{padding: "32px 0 11px 0"}}>
                    <Space>
                        <img src="/images/certificateIcon.svg" alt="" />
                        <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("证书")}</span>
                    </Space>
                </Row>
              </div>
              <Spin spinning={false}>
                <Row style={{ width: "100%" }}>
                  <div className="borderBox">
                    <Form
                      // labelCol={{ span: 6 }}
                      ref={this.formRef}
                    >
                      <Row style={{ width: "100%" }} gutter={[8, 8]} >
                        <Col span={6}>
                          <Form.Item label={t("证书状态")}  name="certificateStatus">
                            <Select
                              allowClear
                              placeholder={t("所有")}
                            >
                              <Select.Option value="0">{t("所有")}</Select.Option>
                              <Select.Option value="1">{t("正常")}</Select.Option>
                              <Select.Option value="2">{t("即将过期")}</Select.Option>
                              <Select.Option value="3">{t("已过期")}</Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        
                        <Col span={6} offset={1}>
                          <Form.Item label={t("剩余有效期")} name="remainingDay">
                            <Input allowClear
                              placeholder={t("输入剩余天数")}
                            ></Input>
                          </Form.Item>
                        </Col>
                        <Col span={11}>
                          <Form.Item wrapperCol={{ offset: 2 }}>
                            <Space size={16}>
                              <Button variant="outlined" onClick={() => { this.onSearchReset(); gaEvent("certificateList", "onClick", "onSearch") }}>
                                {t("重置")}
                              </Button>

                              <Button type="primary" onClick={() => { this.onSearch(); gaEvent("certificateList", "onClick", "onSearch") }}>
                                {t("查询")}
                              </Button>
                            </Space>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                  <div className="borderBox">
                    <Row>
                      <Col className="ms-auto" style={{ marginBottom: 8 }}>
                        <Space size={16}>
                          <Button 
                            type="primary"
                            onClick={() => { this.setState({ isModalVisible: true }); gaEvent("addCertificate", "onClick", "添加证书") }}
                          >
                            <PlusOutlined />{t("添加证书")}
                          </Button>
                        </Space>
                      </Col>
                    </Row>

                    <Table
                      size="middle"
                      loading={loading}
                      dataSource={data}
                      pagination={false}
                      onChange={(pagination) => {}}
                      rowKey={record => record.num}
                      columns={tableColumns.map((item)=>{ 
                        item.title = t(item.title)
                        return item 
                      })}
                      locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                    >
                    </Table>
                    <Pagination
                      style={{ textAlign: "right", marginTop: "20px" }}
                      pageSize={pageSize}
                      current={pageIndex}
                      total={totalCount}
                      showTotal={(total, range) =>
                        `${range[0]}-${range[1]} / ${total} ${t("条")}`
                      }
                      onChange={(page, pageSize) => {
                        this.getList(page, pageSize);
                      }}
                      onShowSizeChange={(current, size) => this.getList(current, size)}
                    ></Pagination>
                  </div>
                </Row>
              </Spin>
              <Modal
                confirmLoading={loading}
                maskClosable={false}
                open={isModalVisible}
                destroyOnClose={true}
                title={t("添加证书")}
                width={"650px"}
                okText={t("确认")}
                cancelText={t("取消")}
                onOk={() => this.onOk()}
                onCancel={() => this.setState({ isModalVisible: false, file: "", password: "", loading: false })}
              >
                <Row gutter={24}>
                  <Col span={24} style={{paddingTop:'20px'}}>
                    <Radio.Group value={fileType} onChange={(e)=>{this.setState({fileType:e.target.value});}}>
                      <Radio value="Upload">上传文件</Radio>
                      <Radio value="Url">文件链接</Radio>
                    </Radio.Group>
                  </Col>
                  {fileType == "Upload" && <>
                    <Col span={6} className="mt-3">
                      <label htmlFor=""><span style={{color: '#ff4d4f', marginRight: '4px', fontSize: '14px', lineHeight: 1, fontFamily: 'SimSun, sans-serif'}}>*</span>{t("证书文件")}</label>
                      <div>
                        <Upload
                          accept=".cer,.crt,.der,.pfx,.p12,.pem"
                          listType="text"
                          showUploadList={true}
                          beforeUpload={() => {
                            return false;
                          }}
                          maxCount={1}
                          onChange={this.uploadFile}
                        >
                          <Button icon={<UploadOutlined />}>{t("点击上传")}</Button>
                        </Upload>
                      </div>
                    </Col>
                  </>
                  }
                  {fileType == "Url" && <Col span={18} className="mt-3">
                    <label htmlFor=""><span style={{color: '#ff4d4f', marginRight: '4px', fontSize: '14px', lineHeight: 1, fontFamily: 'SimSun, sans-serif'}}>*</span>{t("文件链接")}</label>
                    <div>
                      <Input
                        placeholder={t("文件链接")}
                        value={fileUrl}
                        onChange={(e) => this.setState({ fileUrl: e.target.value })}
                      ></Input>
                    </div>
                  </Col>}
                  {/* <Col span={6}>
                    <label htmlFor=""><span style={{color: '#ff4d4f', marginRight: '4px', fontSize: '14px', lineHeight: 1, fontFamily: 'SimSun, sans-serif'}}>*</span>{t("证书文件")}</label>
                    <div>
                      <Upload
                        accept=".cer,.crt,.der,.pfx,.p12,.pem"
                        listType="text"
                        showUploadList={true}
                        beforeUpload={() => {
                          return false;
                        }}
                        maxCount={1}
                        onChange={this.uploadFile}
                      >
                        <Button icon={<UploadOutlined />}>{t("点击上传")}</Button>
                      </Upload>
                    </div>
                  </Col> */}
                  <Col span={24} className="mt-4">
                      <span style={{marginLeft: '10px'}}><InfoCircleOutlined /> {t("支持文件后缀")} .cer/.crt/.der/.pfx/.p12/.pem</span>
                  </Col>
                  <Col span={24} className="mt-3">
                      <label htmlFor="">{t("密码")}</label>
                      <Input.Password onChange={(e) => this.setState({password: e.target.value})}/>
                  </Col>
                </Row>
              </Modal>
            </div>)
          );
        }}</Translation>)
    );
  }
}

export default connect(mapStatetoProps, {})(CertificateListPage);
